'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = require('@material-ui/styles');
var Tabs = require('@material-ui/core/Tabs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Tabs__default = /*#__PURE__*/_interopDefaultLegacy(Tabs);

var SimpleTabs = styles.styled(Tabs__default['default'])(_ref => {
  var {
    theme
  } = _ref;
  return {
    borderBottom: "1px solid ".concat(theme.palette.divider),
    marginBottom: 16,
    '& .MuiTabs-indicator': {
      height: 2
    }
  };
});

exports.SimpleTabs = SimpleTabs;
